<template>
  <div class="dynamic-field">
    <button
        v-if="showRemoveAction"
        class="btn-remove-df"
        title="Remover este campo"
        v-on:click="remove(field)"
    >
      &times;
    </button>
    <b-field
        :label="`${field.title}${field.required ? ' *' : ''}`"
        v-if="field.type === 'text' || field.type === 'number'"
    >
      <input
          :placeholder="field.title"
          :type="field.type"
          :name="field.key"
          :value="dinamycValueFields[field.key]"
          :disabled="field.disabled"
          class="input"
          :v-validate="`${field.required ? 'required': ''}`"
          v-on:input="onChange(field.key, $event.target.value)"
      />
    </b-field>
    <vs-checkbox
        v-if="field.type === 'checkbox'"
        class="justify-content-start checkbox-item align-vertical-checkbox"
        v-model="dinamycValueFields[field.key]"
        :disabled="field.disabled"
    >
      {{ field.title }}
    </vs-checkbox>

    <b-field
        :label="`${field.title}${field.required ? ' *' : ''}`"
        v-if="field.type === 'select' && field.key!=='slot' "
    >
      <b-select
          :placeholder="field.title"
          expanded
          :name="field.key"
          v-model="dinamycValueFields[field.key]"
          :disabled="field.disabled"
      >
        <option
            v-for="option in field.options"
            :value="option.id"
            :key="option.id"
            :id="option.id"
        >
          {{ option.text }}
        </option>
      </b-select>
    </b-field>

    <b-field
        :label="`${field.title}${field.required ? ' *' : ''}`"
        v-if="field.type === 'select' && field.key ==='slot' "
    >
      <b-select
          :placeholder="field.title"
          expanded
          :name="field.key"
          v-model="dinamycValueFields[field.key]"
          :disabled="field.disabled"
      >
        <option
            v-for="option in slotList"
            :value="option.code"
            :key="option.code"
            :id="option.code"
        >
          {{ option.name }}
        </option>
      </b-select>
    </b-field>
  </div>
</template>
<script>
export default {
  props: {
    showRemoveAction: {
      type: Boolean,
    },
    field: {
      type: Object,
      default: {},
    },
    index: {
      type: Number,
      default: 0,
    },
    dinamycValueFields: {
      type: Object,
      default: [],
    },
    slotList: {
      type: Array,
      default: []

    }
  },
  methods: {
    onChange(key, value) {
      this.$emit("onChange", {key: key, value: value});
    },
    remove(field) {
      this.$emit("removeAction", field);
    },
  },
};
</script>
<style>
.align-vertical-checkbox {
  margin-top: 40px;
}
</style>
